// extracted by mini-css-extract-plugin
export default {"innerContainer":"LGy7e5","button":"SoH5kb","additionalWhiteSpace":"E90J9S"};